export class PERMISSION_TYPE {
    static VIEW = "view"
    static ADD = "add"
    static EDIT = "edit"
    static DELETE = "delete"
}

export class PERMISSON_MODULES {
    static CURRENT_ACTIVITY = "CURRENT_ACTIVITY"
    static SEARCH_BY_EMPLOYEE = "SEARCH_BY_EMPLOYEE"
    static CASE_HISTORY = "CASE_HISTORY"
    static CASE_DETAILS = "CASE_DETAILS"
    static DOCUMENTS_PAGE = "DOCUMENTS_PAGE"
    static STD_FORM = "STD_FORM"
    static AIR_FORM = "AIR_FORM"
    static ACMD_FORM = "ACMD_FORM"
    static SETTING_PAGE = "SETTING_PAGE"
    static PROFILE_SETTING = "PROFILE_SETTING"
    static LAST_LOGIN_DETAILS = "LAST_LOGIN_DETAILS"
    static SETTING = "SETTING"
    static FILE_UPLOADS_PAGE = "FILE_UPLOADS_PAGE"
    static LEVEL_DATA_FILE_UPLOADS = "LEVEL_DATA_FILE_UPLOADS"
    static EMPLOYEE_FILE_UPLOADS = "EMPLOYEE_FILE_UPLOADS"
    static NOTIFICATIONS = "NOTIFICATIONS"
    static USERS = "USERS"
    static BACKUP_USER = "BACKUP_USER"
    static DASHBOARD = "DASHBOARD"
    static ABSENCE_TRACKING = "ABSENCE_TRACKING"
    static ASSESSMENTS = "ASSESSMENTS"
    static LTD = "LTD"
    static MY_APPLICATIONS = "MY_APPLICATION"
    static MY_REPORT = "MY_REPORT"
    static REPORT_SETTING = "REPORT_SETTING"
    static CCM_FORM = "CCM_FORM"
}

export class MODULE_TYPE {
    static PAGE = "PAGE"
    static CODE_BLOCK = "CODE_BLOCK"
}